import type { PropsWithChildren } from "react";

import { AppLayout, useAppLayout } from "@/hooks/useAppLayout";
import LayoutAside from "@/layouts/LayoutAside";
import LayoutDefault from "@/layouts/LayoutDefault";
import LayoutNavless from "@/layouts/LayoutNavless";
import GlobalFiltersProvider from "@/providers/GlobalFilters";

export const LayoutDeterminer = ({ children }: PropsWithChildren) => {
  const { appLayout } = useAppLayout();

  if (appLayout === AppLayout.Aside) {
    return <LayoutAside>{children}</LayoutAside>;
  }

  if (appLayout === AppLayout.Navless) {
    return <LayoutNavless>{children}</LayoutNavless>;
  }

  // ! only render the GlobalFiltersProvider (and thus applying various Search Params) when LayoutDefault is activated
  // ! which is most likely the case, when the user is authenticated
  return (
    <GlobalFiltersProvider>
      <LayoutDefault>{children}</LayoutDefault>
    </GlobalFiltersProvider>
  );
};

export default LayoutDeterminer;
